import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { QueryProvider } from '@app/providers/query-provider';
import { SessionProvider } from '@app/providers/session-provider';
import { ThemeProvider } from '@app/providers/theme-provider';
import { router } from '@app/router/router';
import './styles/global.css';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('No se encontro el elemento #root en index.html');
}

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <QueryProvider>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>,
);
